import { useQuery } from "@tanstack/react-query";
import api from "../api";

export function nearbyQueryKey(category, latitude, longitude, radius, text, tagIds, includeDescription) {
  return ["nearby", category, latitude, longitude, radius, text, [...tagIds].sort((a, b) => a - b).join(","), includeDescription];
}

async function fetchNearbyResults({ category, latitude, longitude, radius, text, tags, includeDescription }) {
  const response = await api.get(process.env.REACT_APP_NEARBY_URL, {
    params: {
      lat: latitude,
      lng: longitude,
      radius,
      limit: 50,
      type: category === "eventy" ? "events" : "places",
      text: text || undefined,
      tags: tags.length ? tags.map((tag) => tag.value).join(",") : undefined,
      includeDescription: includeDescription ? "1" : undefined,
    },
  });

  return response.data ?? {};
}

export function useNearbyQuery({ category, location, radius, text, tags, includeDescription, enabled }) {
  const tagIds = tags.map((tag) => tag.id);
  return useQuery({
    queryKey: nearbyQueryKey(category, location?.lat, location?.lng, radius, text, tagIds, includeDescription),
    queryFn: () => fetchNearbyResults({
      category,
      latitude: location.lat,
      longitude: location.lng,
      radius,
      text,
      tags,
      includeDescription,
    }),
    enabled,
    staleTime: 30_000,
  });
}
